(() => {
  'use strict';
  const registryKey = '__moreheaCollectionLayout';
  if (window[registryKey]) { window[registryKey].mount(document); return; }
  const storageKey = 'morehea:collection-layout';
  const instances = new Map();
  const isLayout = (value) => value === 'grid' || value === 'list';

  function create(root) {
    let preference = 'grid';
    let destroyed = false;
    const desktop = window.matchMedia('(min-width: 750px)');
    const initializedDetails = new WeakSet();
    try { const saved = window.localStorage.getItem(storageKey); if (isLayout(saved)) preference = saved; } catch (_) { /* Layout works without storage permission. */ }

    function apply() {
      if (destroyed) return;
      const layout = desktop.matches ? preference : 'grid';
      root.dataset.mhLayout = layout;
      root.querySelectorAll('[data-mh-view-controls]').forEach((controls) => { controls.hidden = false; });
      root.querySelectorAll('[data-mh-view]').forEach((button) => { button.setAttribute('aria-pressed', String(button.dataset.mhView === layout)); });
      if (desktop.matches) {
        root.querySelectorAll('.facets__disclosure-vertical').forEach((details) => {
          if (!initializedDetails.has(details) && details.querySelector('price-range')) {
            details.open = true;
            initializedDetails.add(details);
          }
        });
      }
    }
    function onClick(event) {
      if (!(event.target instanceof Element) || !desktop.matches) return;
      const button = event.target.closest('[data-mh-view]');
      if (!button || !root.contains(button) || !isLayout(button.dataset.mhView)) return;
      preference = button.dataset.mhView;
      try { window.localStorage.setItem(storageKey, preference); } catch (_) { /* In-memory preference remains usable. */ }
      apply();
    }
    function onStorage(event) {
      if (event.key === storageKey && isLayout(event.newValue)) { preference = event.newValue; apply(); }
    }
    const observer = new MutationObserver(apply);
    // Dawn replaces ProductGridContainer.innerHTML and facet contents after AJAX.
    // Presentation is scoped on the persistent root and reapplied to new content.
    observer.observe(root, { childList: true, subtree: true });
    root.addEventListener('click', onClick);
    window.addEventListener('storage', onStorage);
    if (typeof desktop.addEventListener === 'function') desktop.addEventListener('change', apply);
    else desktop.addListener(apply);
    apply();
    return { destroy() {
      destroyed = true;
      observer.disconnect();
      root.removeEventListener('click', onClick);
      window.removeEventListener('storage', onStorage);
      if (typeof desktop.removeEventListener === 'function') desktop.removeEventListener('change', apply);
      else desktop.removeListener(apply);
      root.dataset.mhLayout = 'grid';
      root.querySelectorAll('[data-mh-view-controls]').forEach((controls) => { controls.hidden = true; });
      instances.delete(root);
    } };
  }
  function mount(scope) {
    instances.forEach((instance, root) => { if (!root.isConnected) instance.destroy(); });
    const roots = [];
    if (scope instanceof Element && scope.matches('[data-mh-collection]')) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll('[data-mh-collection]'));
    roots.forEach((root) => { if (!instances.has(root)) instances.set(root, create(root)); });
  }
  window[registryKey] = { mount };
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => { instances.forEach((instance, root) => { if (event.target === root || event.target.contains(root)) instance.destroy(); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
})();
